import HeadMeta from './HeadMeta';

export default HeadMeta;
